// https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
// https://javascript.plainenglish.io/use-constructor-in-react-functional-component-with-custom-hooks-e0770e92b840
// https://blog.csdn.net/qq_20567691/article/details/106035547

import {useEffect,useState,useMemo,useContext, Key} from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar ,IonBackButton,IonButtons,IonIcon,IonItem,IonButton,
  IonCard,IonImg,useIonModal,
  IonGrid,IonCol,IonRow,
  IonLabel,IonInput,IonSelect,IonSelectOption,
  useIonToast,
  IonModal,
  IonList,
  IonDatetime
} from '@ionic/react';


import { happy,chevronBackOutline } from 'ionicons/icons';

import { useHistory,useLocation } from "react-router";


import {restPost, uploadAsset, uploadBinary, uploadConfig} from "../hooks/AdminHttp";



import styles from '../common/styles.module.css'
import _styles from './GenericPost.module.css'
import UploaderField from '../components/UploaderField';
import { stat } from 'fs';
import UploadModal from '../components/UploadModal';
import ForeignModal from '../components/ForeignModal';
import enums from '../type/enums';
import NullableTextField from '../components/NullableTextField';
import GenericField from '../components/GenericField';
import { obj2json } from '../common/object_util';
Object.assign(styles,_styles);


interface Json {[key:string]:any};

const GenericFilter: React.FC<{
  // history:any,
  // context:any,
  meta:Json,
  entities:Json,
  filter:Json,
  onCloseClicked:(filter:Json)=>void
}> = ({meta, entities,filter, onCloseClicked}) => {

  const [state,setState] = useState<{[key:string]:any}>({});

  const [item,setItem] = useState<{[key:string]:any}>(filter);


  const [toastPresent,toastDismiss] = useIonToast();

  useEffect(()=>{


  },[]);


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>

          <IonTitle>设置过滤条件[{meta.name}]</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={()=>onCloseClicked(null)}>取消</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
      <IonList inset={true}>
        {
          meta.filter_fields.map((key:string,index:Number)=>{
            let fieldMeta = meta.fields[key ];
            // fieldMeta.key = key;

            return <IonItem key={key}>
              <IonLabel position={"floating"}>{fieldMeta.name}</IonLabel>
              <GenericField  value={item[key]} setValue={(v:any,...attachs:any)=>{


                if (v === undefined) return;


                if (fieldMeta.attach_field && attachs){
                  setItem({...item,[key]: v, [fieldMeta.attach_field]:attachs[0]});
                }else{

                  setItem({...item,[key]: v});
                }


              }} fieldMeta={fieldMeta} entities={entities[(fieldMeta.key ||  key) + 's']} />
    
            </IonItem>;

            
          })
        }
      </IonList>

      </IonContent>


      <IonItem lines="none">
          <IonButton slot="start" fill="clear" onClick={()=>onCloseClicked({})}>清空条件</IonButton>
          <IonButton slot="end"  size="default" color="secondary" expand="block" fill="solid" onClick={()=>{

            const invalidUuid = meta.filter_fields.find((key:string)=>
              meta.fields[key].type === 'uuid' && item[key] && String(item[key]).trim() &&
              !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(item[key]).trim()));
            if (invalidUuid) {
              toastPresent({message: `${meta.fields[invalidUuid].name} 格式不正确，请输入完整 UUID`, duration: 3000, color: 'danger'});
              return;
            }
            onCloseClicked(obj2json(item,meta.filter_fields));
            
          }} >确认</IonButton>
      </IonItem>

    </IonPage>
  );
};

export default GenericFilter;
